const privacyEN = {
  seo: {
    title: "Privacy Policy | QuadroCode",
    description:
      "Read QuadroCode's privacy policy, including what information we collect, how we use it, and how to contact us.",
  },
  hero: {
    eyebrow: "Privacy and data handling",
    title: "Privacy Policy",
    intro:
      "This page explains how QuadroCode collects, uses, shares, and protects information when you visit www.quadrocode.com.",
    effectiveDateLabel: "Effective date",
    updatedLabel: "Last updated",
    effectiveDate: "March 1, 2026",
    updatedDate: "March 1, 2026",
    websiteLabel: "Website",
    websiteValue: "www.quadrocode.com",
    contactLabel: "Privacy contact",
    contactValue: "info@quadrocode.com",
  },
  jumpLabel: "Jump to section",
  quickFacts: [
    {
      icon: "shield",
      title: "No sale of personal data",
      text: "We do not sell your personal information.",
    },
    {
      icon: "cookie",
      title: "Cookies in use",
      text: "Cookies and analytics tools may be used for traffic and preference insights.",
    },
    {
      icon: "rights",
      title: "Your rights",
      text: "You may request access, correction, deletion, or withdrawal of consent where applicable.",
    },
  ],
  sections: [
    {
      id: "introduction",
      number: "01",
      title: "Introduction",
      icon: "document",
      paragraphs: [
        'Welcome to QuadroCode ("Company", "we", "our", "us"). This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit www.quadrocode.com.',
        "If you do not agree with the terms of this policy, please do not access the website.",
      ],
    },
    {
      id: "information-we-collect",
      number: "02",
      title: "Information We Collect",
      icon: "globe",
      subsections: [
        {
          title: "Personal Information",
          items: [
            "Full name",
            "Email address",
            "Phone number",
            "Company name",
            "Project details submitted via forms",
            "Any information you voluntarily provide",
          ],
        },
        {
          title: "Automatically Collected Information",
          items: [
            "IP address",
            "Browser type",
            "Device information",
            "Pages visited",
            "Time spent on pages",
            "Referral sources",
          ],
          note: "This data is collected via cookies and analytics tools.",
        },
      ],
    },
    {
      id: "how-we-use-information",
      number: "03",
      title: "How We Use Your Information",
      icon: "usage",
      items: [
        "Respond to inquiries",
        "Provide project proposals and consultations",
        "Improve our services",
        "Analyze website performance",
        "Communicate updates or offers if you have consented",
        "Ensure website security",
      ],
    },
    {
      id: "cookies",
      number: "04",
      title: "Cookies and Tracking Technologies",
      icon: "cookie",
      paragraphs: ["We use cookies and similar technologies to:"],
      items: ["Improve user experience", "Analyze traffic", "Remember preferences"],
      note: "You may disable cookies in your browser settings.",
    },
    {
      id: "sharing",
      number: "05",
      title: "Sharing Your Information",
      icon: "lock",
      paragraphs: ["We do not sell your personal information."],
      preface: "We may share data with:",
      items: [
        "Hosting providers",
        "Analytics providers such as Google Analytics",
        "Payment processors, if applicable",
        "Legal authorities if required by law",
      ],
    },
    {
      id: "retention",
      number: "06",
      title: "Data Retention",
      icon: "shield",
      paragraphs: ["We retain personal data only as long as necessary for:"],
      items: ["Business purposes", "Legal compliance", "Contractual obligations"],
    },
    {
      id: "security",
      number: "07",
      title: "Data Security",
      icon: "lock",
      paragraphs: [
        "We implement technical and organizational measures to protect your data. However, no online transmission is 100% secure.",
      ],
    },
    {
      id: "rights",
      number: "08",
      title: "Your Rights",
      icon: "rights",
      paragraphs: ["Depending on your jurisdiction, you may have the right to:"],
      items: [
        "Access your data",
        "Request correction",
        "Request deletion",
        "Withdraw consent",
        "Object to processing",
      ],
      note: "To exercise your rights, contact us at info@quadrocode.com.",
    },
    {
      id: "third-party-links",
      number: "09",
      title: "Third-Party Links",
      icon: "globe",
      paragraphs: [
        "Our website may contain links to third-party websites. We are not responsible for their privacy practices.",
      ],
    },
    {
      id: "changes",
      number: "10",
      title: "Changes to This Policy",
      icon: "document",
      paragraphs: ["We may update this policy periodically. Changes will be posted on this page."],
    },
    {
      id: "contact-information",
      number: "11",
      title: "Contact Information",
      icon: "mail",
      contactCard: {
        company: "Quadrocode LTD",
        addressLines: ["UK, Suite 402, Level 4, Newford", "UK"],
        email: "info@quadrocode.com",
      },
    },
  ],
  backHome: "Back to home",
};

export default privacyEN;
